import { useState, useEffect } from "react";
import { createApiClient } from "../Network/ApiClient";

const featuresApi = createApiClient("features/");

let cachedFeatures: Record<string, boolean> | null = null;
let fetchPromise: Promise<void> | null = null;

export function useFeatureStatus(featureKey: string) {
  const [isEnabled, setIsEnabled] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        if (!cachedFeatures) {
          if (!fetchPromise) {
            fetchPromise = featuresApi.get("").then((res) => {
              const map: Record<string, boolean> = {};
              (res.data.features || []).forEach((f: any) => {
                map[f.feature_key] = f.is_enabled;
              });
              cachedFeatures = map;
            });
          }
          await fetchPromise;
        }
        setIsEnabled(cachedFeatures?.[featureKey] ?? false);
      } catch {
        setIsEnabled(true); // fail-open
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [featureKey]);

  return { isEnabled, loading };
}

export function invalidateFeatureCache() {
  cachedFeatures = null;
  fetchPromise = null;
}